export default __webpack_public_path__ + "static/media/12-min.3a9b08da.jpg";